export default {
  l: {
    add: "Добави",
    addCashDesk: "Добави каса",
    addChannel: "Добави канал",
    addCity: "Добави град",
    addChannelClientCompositionMapping: "Добави картографиране на клиентски състав на канал",
    addChannelHotelRateCodeMapping: "Добави картографиране на код за хотелска тарифа на канал",
    addChannelHotelRoomTypeMapping: "Добави картографиране на тип стая на хотел на канал",
    addCountry: "Добави държава",
    addCreditCardType: "Добави тип кредитна карта",
    addGeneralJournal: "Добави общ журнал",
    addJournalAccountType: "Добави тип сметка в журнал",
    addJournalBatch: "Добави партида в журнал",
    addJournalTemplate: "Добави шаблон на журнал",
    addRoomStatus: "Добави статус на стая",
    addRoomType: "Добави тип стая",
    adminCode: "Административен код",
    adminName: "Административно име",
    adminNameAscii: "Административно име ASCII",
    adminType: "Административен тип",
    amountAfterDiscount: "Сума след отстъпка",
    backOffice: "Бек офис",
    bankAccount: "Банкова сметка",
    bankAccountId: "ID на банкова сметка",
    bookingSource: "Източник на резервация",
    cancel: "Отказ",
    capital: "Столица",
    cashDesk: "Каса",
    channel: "Канал",
    channelAgencyCode: "Код на агенция на канал",
    channelClientCompositionMapping: "Картографиране на клиентски състав на канал",
    channelHotelRateCodeMapping: "Картографиране на код за хотелска тарифа на канал",
    channelHotelRoomTypeMapping: "Картографиране на тип стая на хотел на канал",
    channelId: "ID на канал",
    channelManager: "Мениджър на канал",
    channelRateCode: "Код на тарифа на канал",
    channelRoomType: "Тип стая на канал",
    channelRoomTypeCode: "Код на тип стая на канал",
    city: "Град",
    cityAlt: "Алтернативен град",
    cityAscii: "Град ASCII",
    code: "Код",
    country: "Държава",
    countryId: "ID на държава",
    credit: "Кредит",
    creditCard: "Кредитна карта",
    creditCardType: "Тип кредитна карта",
    customer: "Клиент",
    customerNo: "Клиентски номер",
    customerLedger: "Клиентска книга",
    dashboard: {
      activity: "Дейност",
      weeklySales: "Седмични продажби",
      sales: "Продажби",
      recentOrders: "Последни поръчки",
      sources: "Източници на трафик",
      lastweek: "спрямо миналата седмица",
      orders: "Поръчки",
      customers: "Клиенти",
      tickets: "Билети за поддръжка",
      viewReport: "Виж доклада",
      totalPaidOrders: "Общо платени поръчки",
      totalAmount: "Обща сума",
      totalTaxes: "Общо данъци",
      grandTotal: "Голям общ сбор",
      totalQty: "Общо количество",
      totalGuests: "Общо гости",
      totalQuickOrders: "Общо бързи поръчки",
      foodTotalAmount: "Обща сума за храна",
      foodTotalQty: "Общо количество храна",
      beverageTotalAmount: "Обща сума за напитки",
      beverageTotalQty: "Общо количество напитки",
      othersTotalAmount: "Обща сума за други",
      othersTotalQty: "Общо количество други",
      tobaccoTotalAmount: "Обща сума за тютюн",
      tobaccoTotalQty: "Общо количество тютюн",
      totalCovers: "Общо покрити (обслужени гости)",
      averageSpendPerGuest: "Среден разход на гост",
      averageTransactionValue: "Средна стойност на транзакция",
      assumedTableTurnTime: "Предполагаемо време за обръщане на маса",
      averageTableTurnTime: "Средно време за обръщане на маса",
      seatingCapacity: "Капацитет на сядане",
      totalItemsSold: "Общо продадени артикули",
      totalTransactions: "Общо транзакции",
      summaryMetrics: "Обобщени метрики",
      potentialCoversPerMealtime: "Потенциални покрити на хранене",
      serviceCharge: "Такса за обслужване ({percent}% от приходите)",
      vatRevenue: "ДДС ({percent}% от приходите)",
      netSales: "Нетни продажби (без данъци и обслужване)",
      dateRangeTo: "Период: {s} до {e}",
      topThreeItemsSold: "Топ три продадени артикула",
      topDiscounts: "Топ отстъпки",
      outletHours: "Работно време на обекта:",
      breakfast: "Закуска",
      lunch: "Обяд",
      dinner: "Вечеря",
      allDayDining: "Цял ден хранене",
      potentialCoversPerMealTimeDesc: "{potential_cover_per_mealtime} покрити ({seating_capacity} места x {potential_turns_per_mealtime} обръщания)",
      occupancyRateDesc: "{occupancy_rate} % ({total_covers} гост / {total_seats} места x {potential_turns_per_mealtime} обръщания за {days_config} дни)",
      mealTime: "Време за хранене",
      allRevenueExcludingComplimentary: "*Всички приходи, без комплиментни артикули.",
      complimentaryExcluded: "*Комплиментни артикули изключени",
      allRevenueAllDayIncludeComplimentary: "*Всички приходи са от целодневно хранене и включват комплиментни услуги.",
    },
    defaultBookingSource: "Стандартен източник на резервация",
    defaultMarketSegment: "Стандартен пазарен сегмент",
    delete: "Изтрий",
    deleteConfirmation: "Потвърждение за изтриване",
    density: "Плътност",
    description: "Описание",
    documentNo: "Номер на документ",
    documentType: "Тип документ",
    edit: "Редактирай",
    editCashDesk: "Редактирай каса",
    editChannel: "Редактирай канал",
    editCity: "Редактирай град",
    editChannelClientCompositionMapping: "Редактирай картографиране на клиентски състав на канал",
    editChannelHotelRateCodeMapping: "Редактирай картографиране на код за хотелска тарифа на канал",
    editChannelHotelRoomTypeMapping: "Редактирай картографиране на тип стая на хотел на канал",
    editCountry: "Редактирай държава",
    editCreditCardType: "Редактирай тип кредитна карта",
    editGeneralJournal: "Редактирай общ журнал",
    editJournalAccountType: "Редактирай тип сметка в журнал",
    editJournalBatch: "Редактирай партида в журнал",
    editJournalTemplate: "Редактирай шаблон на журнал",
    editRoomStatus: "Редактирай статус на стая",
    editRoomType: "Редактирай тип стая",
    entryNo: "Номер на запис",
    failed: "Неуспешно",
    frontOffice: "Фронт офис",
    generalJournal: "Общ журнал",
    hotelAgency: "Хотелска агенция",
    hotelAgencyGroup: "Група хотелски агенции",
    hotelClient: "Клиент на хотел",
    hotelRate: "Хотелска тарифа",
    hotelRoomType: "Тип стая на хотел",
    iso2Code: "ISO2 код",
    journalAccountNo: "Номер на сметка в журнал",
    journalAccountType: "Тип сметка в журнал",
    journalBatch: "Партида в журнал",
    journalTemplate: "Шаблон на журнал",
    latitude: "Ширина",
    lineNo: "Номер на ред",
    longitude: "Дължина",
    mandatory: "Задължително",
    marketSegment: "Пазарен сегмент",
    masterData: "Основни данни",
    name: "Име",
    new: "Нов",
    no: "Не",
    numericCode: "Числов код",
    officialStateName: "Официално име на държавата",
    originalAmount: "Оригинална сума",
    population: "Население",
    populationProper: "Точно население",
    postingDate: "Дата на осчетоводяване",
    rate: "Тарифа",
    ranking: "Класиране",
    roomStatus: "Статус на стая",
    roomType: "Тип стая",
    sameName: "Същото име",
    save: "Запази",
    simpleMapsCityId: "ID на град SimpleMaps",
    successful: "Успешно",
    timezone: "Часова зона",
    yes: "Да",
    variance: "Вариация",
    mealDate: "Дата на хранене",
    cannotModifySelectedData: "Не може да се модифицират избраните данни",
    startOperatingHour: "Начален работен час",
    endOperatingHour: "Краен работен час",
    foodAndBeverage: "Храни и напитки",
    allDepartments: "Всички отдели",
    selectAllDepartments: "Избери всички отдели",
    currCollectionType: "Текущ тип колекция",
    changeCollectionType: "Промени тип колекция",
    addItem: "Добави {item}",
    quickOrder: "Бърза поръчка",
    mealTimeSetup: "Настройка на време за хранене",
    tableReservation: "Резервация на маса",
    breakfastRegistration: "Регистрация за закуска",
    mealRegistration: "Регистрация на хранене",
    roomBreakfastRegistration: "Регистрация за закуска в стая",
    roomLunchRegistration: "Регистрация за обяд в стая",
    roomDinnerRegistration: "Регистрация за вечеря в стая",
    banquetLunchRegistration: "Регистрация за обяд на банкет",
    banquetDinnerRegistration: "Регистрация за вечеря на банкет",
    itemLoan: "Заем на артикул",
    courseStage: "Етап на курс",
    intercompanyMapping: "Междуфирмено картографиране",
    guestProfiles: "Профили на гости",
    cancelConfirmation: "Отмяна на потвърждение",
    salesByTableLabelReport: "Отчет за продажби по етикет на таблица",
    label: "Етикет",
    betaTesting: "Бета тестване",
    currentItem: "Текущ {item}",
    changeItem: "Промени {item}",
    edcMachineIntegration: "Интеграция на EDC машина",
    enableEdcMachine: "Активирайте EDC машина",
    edcMode: "EDC Режим",
    edcModeAlways: "Винаги използвайте EDC",
    edcModePrompt: "Подканете касиера да избере",
    edcAgentUrl: "URL на Sentec агент",
    edcAgentUrlPlaceholder: "Оставете празно, за да използвате URL на pos.agent",
    edcAgentUrlHint: "Връща се към pos.agent URL, ако не е зададен",
    edcAgentToken: "Токен на агента Sentec",
    edcAgentTokenPlaceholder: "Оставете празно, за да използвате токена на pos.agent",
    edcAgentTokenHint: "Заменя токена pos.agent при задаване",
    edcVendor: "Доставчик на EDC",
    edcComPort: "COM порт",
    edcComPortPlaceholder: "напр. COM3",
    edcTestConnection: "Тест на връзката",
    edcConnected: "Свързан",
    edcFailed: "Неуспех",
    edcEnterAgentUrlFirst: "Моля, първо въведете URL адреса на Sentec Agent.",
    edcPayment: "Плащане EDC",
    edcInvoiceAmountRemaining: "Оставаща сума за фактурата",
    edcUserPayment: "Плащане на потребител",
    edcTerminalWillReceive: "Терминалът ще получи: {amount} ({currency} малки единици)",
    edcChange: "Промяна",
    edcRemainingPayment: "Оставаща сума",
    edcPressPayToInitiate: "Натиснете Плати, за да инициирате EDC транзакция",
    edcWaitingForCard: "Изчакване на карта...",
    edcSecondsRemaining: "{seconds}с оставащи",
    edcCancel: "Отмяна",
    edcTransactionApproved: "Транзакцията е одобрена",
    edcTransactionFailed: "Транзакцията неуспешна",
    edcRetry: "Опитай отново",
    edcPayViaEdc: "Плащане чрез EDC",
    edcConfirm: "Потвърди",
    edcCard: "Картичка",
    edcAuthCode: "Код за удостоверяване",
    edcTraceNumber: "Проследяване #",
    edcTerminal: "Терминал",
    edcTransactionDeclined: "Транзакцията е отказана",
    edcConnectionFailed: "Неуспешно свързване с EDC терминал",
    edcTotalPaymentAlreadyEqual: "Общото плащане вече е равно на сумата на фактурата.",
    postingGroupFollowsClient: "Не е зададена група за публикуване на клиента - групата следва клиента",
    lockClientPostingGroup: "Заключване на група за публикуване на клиенти",
  },
  m: {
    dimensionValueNotInDimension: "Тази стойност принадлежи на друго измерение. Изберете стойност от избраното измерение.",
    dimensionSetupOwnerChanged: "Избраният запис се промени. Измерението не беше запазено — отворете настройката отново и опитайте пак.",
    saveFirstBeforeDimensionSetup: "Първо запазете този запис, след което конфигурирайте измеренията му.",
    fieldIsRequired: "Това поле е задължително",
    confirmDelete: "Сигурни ли сте, че искате да изтриете {f}? Този процес не може да бъде отменен.",
    err: {
      betLen: "{f} трябва да бъде между {v1} и {v2} символа",
      ge: "{f} трябва да бъде по-голямо или равно на {v}",
      gt: "{f} трябва да бъде по-голямо от {v}",
      le: "{f} трябва да бъде по-малко или равно на {v}",
      lt: "{f} трябва да бъде по-малко от {v}",
      maxLen: "{f} трябва да бъде максимум {v} символа",
      maxVal: "Максималната стойност на {f} е {v}{x}",
      minLen: "{f} трябва да бъде минимум {v} символа",
      minMaxVal: "Стойността на {f} трябва да бъде от {v1}{x} до {v2}{x}",
      minVal: "Минималната стойност на {f} е {v}{x}",
      number: "{f} трябва да бъде число, положително или отрицателно",
      numeric: "{f} трябва да съдържа само цифри",
      req: "{f} е задължително",
      cantXWhileOffline: "Не може {x} без интернет",
      duplicate: "{f} {v} вече съществува",
    },
    confirmCancel: "Сигурни ли сте, че искате да отмените {f}? Този процес не може да бъде отменен.",
    confirmLogout: "Сигурни ли сте, че искате да излезете?",
    confirmFlushSiteData: "Сигурни ли сте, че искате да изчистите данните на сайта? Това ще ви излезе и ще презареди страницата.",
    successFlushSiteData: "Данните на сайта са изчистени. Ще бъдете излезли и страницата ще се презареди.",
    invalidPhoneNumber: "Невалиден телефонен номер, разрешени са само цифри и +",
    invalidDateOfBirth: "Невалидна дата на раждане. Моля, използвайте формат ГГГГ-ММ-ДД.",
  },
  common: {
    add: "Добави",
    cancel: "Отказ",
    description: "Описание",
    delete: "Изтрий",
    title: "Заглавие",
    save: "Запази",
    faq: "ЧЗВ",
    contact: "Свържете се с нас",
    tos: "Условия за ползване",
    policy: "Политика за поверителност",
    articleFlavour: "Вкус на статията",
    showFlavour: "Покажи вкуса",
    hide: "Скрий",
    articleGroupName: "Група артикули",
    created: "Създадено",
    updated: "Обновено",
    deleted: "Изтрито",
  },
  agent: {
    sentecAgentConfigSettings: "Настройки на конфигурацията на Sentec Agent",
    sentecAgentAccounts: "Sentec Agent акаунти (V2)",
    sentecAgentAccountsDesc: "Sentec Agent акаунти за използване на WebSocket комуникационен протокол",
    availableDownloads: "Налични изтегляния",
    checkVersion: "Провери версията",
    pleaseCheckDeviceConfigurationSentecAgent: "Моля, проверете дали устройството, конфигурацията и услугата Sentec Agent са правилно настроени и работят",
    pleaseCheckDeviceAndConfigAndPMSInterfaceServer: "Моля, проверете дали устройството и конфигурацията са правилно настроени. Ако всичко е наред, уверете се, че PMS Interface Server работи",
    viewDownloads: "Виж изтеглянията",
  },
  board: {
    titlePlaceholder: "Въведете заглавие за тази карта",
    deleteDescription: "Сигурни ли сте, че искате да изтриете тази карта?",
    editCard: "Редактирай карта",
    deleteCard: "Изтрий карта",
    state: {
      TODO: "ЗА ИЗПЪЛНЕНИЕ",
      INPROGRESS: "В ПРОЦЕС",
      TESTING: "ТЕСТВАНЕ",
      DONE: "ГОТОВО",
    },
  },
  chat: {
    online: "Потребители онлайн ({count})",
    addChannel: "Добави канал",
    channel: "Канал | Канали",
    message: "Съобщение",
  },
  email: {
    compose: "Създай имейл",
    send: "Изпрати",
    subject: "Тема",
    labels: "Етикети",
    emptyList: "Празен списък с имейли",
    inbox: "Входящи",
    sent: "Изпратени",
    drafts: "Чернови",
    starred: "Отбелязани със звезда",
    trash: "Кошче",
    work: "Работа",
    invoice: "Фактура",
    notValid: "Невалиден имейл",
  },
  todo: {
    addTask: "Добави задача",
    tasks: "Задачи",
    completed: "Завършени",
    labels: "Етикети",
  },
  usermenu: {
    profile: "Профил",
    signin: "Вход",
    dashboard: "Табло",
    signout: "Изход",
  },
  error: {
    notfound: "Страницата не е намерена",
    other: "Възникна грешка",
    failedUpdateOrder: "Неуспешно обновяване на поръчката",
    noPermission: "Нямате разрешение да извършите това действие",
  },
  check: {
    title: "Задайте нова парола",
    backtosign: "Обратно към вход",
    newpassword: "Нова парола",
    button: "Задайте нова парола и влезте",
    error: "Връзката за действие е невалидна",
    verifylink: "Проверка на връзката...",
    verifyemail: "Проверка на имейл адреса...",
    emailverified: "Имейлът е потвърден! Пренасочване...",
  },
  forgot: {
    title: "Забравена парола?",
    subtitle: "Въведете имейл адреса на акаунта си и ще ви изпратим връзка за нулиране на паролата.",
    email: "Имейл",
    button: "Заявете нулиране на паролата",
    backtosign: "Обратно към вход",
  },
  login: {
    title: "Вход",
    email: "Имейл",
    password: "Парола",
    button: "Вход",
    orsign: "Или влезте с",
    forgot: "Забравена парола?",
    noaccount: "Нямате акаунт?",
    create: "Създайте един тук",
    error: "Комбинацията имейл / парола е невалидна",
  },
  register: {
    title: "Създаване на акаунт",
    name: "Пълно име",
    email: "Имейл",
    password: "Парола",
    passwordRetype: "Повторете паролата",
    button: "Създайте акаунт",
    orsign: "Или се регистрирайте с",
    agree: "С регистрацията си се съгласявате с",
    account: "Вече имате акаунт?",
    signin: "Вход",
  },
  order: {
    cantCorrectPaymentBecauseTaxInterfaceStatusIsValid: "Не може да се коригира плащането, защото статусът на данъчния интерфейс е валиден",
    cantDeletePaymentBecauseTaxInterfaceStatusIsValid: "Не може да се изтрие плащането, защото статусът на данъчния интерфейс е валиден",
    redirectReceiptVerificationURL: "Пренасочване към URL за проверка на разписка",
    deleteSentOrder: "Изтрий изпратена поръчка",
    closeOrder: "Затвори поръчка",
    closeOrderConfirmation: "Сигурни ли сте, че искате да затворите тази поръчка?",
  },
  parameter: {
    stickyLabelPrintSettings: "Настройки за печат на самозалепващи етикети",
    maxPreviewBillPrintCount: "Максимален брой предварителни разпечатки на фактури",
    maxPreviewBillPrintCountReached: "Превишен лимит за печат: Достигнахте максималния разрешен брой предварителни разпечатки на фактури.",
    maxPreviewBillPrintCountLimit0: "Въведете '0' за без лимит",
    numberSeriesAndVATExemption: "Номер, серия и освобождаване от ДДС",
    billPrintSettings: "Настройки за печат на фактури",
    wrapText: "Пренасяне на текст",
    defaultPrinter: "Принтер по подразбиране",
    fontSize: "Размер на шрифта (в точки)",
    topMargin: "Горен марж (в точки)",
    leftMargin: "Ляв марж (в точки)",
    rightMargin: "Десен марж (в точки)",
    bottomMargin: "Долен марж (в точки)",
    lineOffset: "Офсет на реда (в точки)",
    hideHotelNameInBillPrint: "Скрий името на хотела във фактурата",
    vatRegNo: "ДДС регистрационен номер",
    minNo: "Мин. номер",
    snNo: "Сериен номер",
    checkNoSeries: "Серия номер за чек",
    receiptNoSeries: "Серия номер за разписка",
    permitNo: "Разрешителен № (STN S/N)",
    accreditedNo: "Акредитиран номер",
    isEnableExemptVAT: "Разреши освобождаване от ДДС",
    allowDeleteSentItems: "Позволи изтриване на изпратени артикули",
    showBraceletAsCollectionType: "Покажи гривна като тип колекция",
    headerText1: "Текст на заглавието 1",
    headerText2: "Текст на заглавието 2",
    footerText1: "Текст на долния колонтитул 1",
    footerText2: "Текст на долния колонтитул 2",
    salesCreditMemoSeries: "Серия кредитно известие за продажби",
    isSupportExternal: "Поддържа външни устройства",
    isCardNumberNotMandatory: "Номерът на картата не е задължителен",
    isCardNameNotMandatory: "Името на картата не е задължително",
    isCardTraceNoNotMandatory: "Номерът на проследяване не е задължителен",
    isDeleteSentOrderReasonNotMandatory: "Причината за изтриване на изпратена поръчка не е задължителна",
    isCancelOrderReasonNotMandatory: "Причината за анулиране на поръчка не е задължителна",
    isPrintCancelOrderDoc: "Отпечатай документ за анулиране на поръчка при изтриване на изпратена поръчка",
    splitBillByItem: "Allow Split Bill by Item",
    enableTips: "Активиране на бакшиши",
    enableTipsHint: "Записване на бакшиши от клиенти (в брой/карта) в диалога за плащане",
    isPrintBillOnQuickOrder: "Печат на сметка при бърза поръчка",
    isSendFoodOnQuickOrder: "Изпращане на хранителен продукт при бърза поръчка",
    isSendBeverageOnQuickOrder: "Изпращане на напитка при бърза поръчка",
    isSendOthersOnQuickOrder: "Изпращане на други продукти при бърза поръчка",
    isSendTobaccoOnQuickOrder: "Изпращане на тютюневи изделия при бърза поръчка",
    showGuestSignatureFieldInPreviewBill: "Показване на поле за подпис на госта във визуализацията на сметката",
    showRoomNoFieldInPreviewBill: "Показване на поле за номер на стая във визуализацията на сметката",
    showTipFieldInPreviewBill: "Показване на поле за бакшиш във визуализацията на сметката",
    font: "Шрифт",
    textBold: "Удебелен текст",
    sendOrderPrintSettings: "Настройки за печат на изпратена поръчка",
    amountOfBillToPrintOnProcessingPayment: "Брой копия на сметката при обработка на плащане",
    isMultiplePaymentGroupedByType: "Множествено плащане групирано по тип",
    billPrintShowGuestPaymentAmountOnCash: "Показване на сума на плащане от гост при плащане в брой",
    billPrintLogoWidth: "Ширина на логото (в точки)",
    applyDiscountAndAllowance: "Прилагане на отстъпки и надбавки",
    discountArticle: "Свържи с този артикул",
    discountAndAllowance: "Отстъпка и надбавка",
    applyingDiscountAndAllowancesWill: "Прилагането на отстъпки и надбавки ще",
    activateTheDiscountTotalFeature: "Активирай функцията за обща отстъпка",
    generateDiscountRevenueLinesForBoth: "Генерирай редове за приходи от отстъпки и за двете",
    perItemDiscounts: "Отстъпки на артикул",
    totalDiscounts: "Общи (на ниво поръчка) отстъпки",
    theDiscountTotalWillBeMappedToTheSelectedArticle: "Общата отстъпка ще бъде свързана с избрания артикул",
    showGuestNameInSendOrder: "Показване на името на госта при изпращане на поръчката",
    allowZeroCover: "Разрешаване на нулево покритие",
    defaultItem: "По подразбиране {item}",
    serialNo: "Сериен №",
    stnSn: "STN S/N",
    layoutCSalesInvoiceStatement: "Декларация за фактура за продажби Layout C",
    showManualOrNumber: "Показване на ръчно въвеждане или номер (в брой и с карта)",
    showPackageOrderDetailPrice: "Показвай цената на детайлите в пакета",
    allowPackageMemberDiscount: "Разреши отстъпка за артикули в пакет",
    packageGroupName: "Име на групата пакети",
    birZCounterSeries: "BIR Z Counter Series",
    hideTaxInLayoutCommonD: "Скрий ДДС и такса услуга",
    hideTaxInLayoutCommonDHint: "Само за оформление Общ D (Камбоджийски)",
    billPrintCombineTaxLines: "Обедини данък и допълнителен данък в един ред",
    billPrintCombineTaxLinesHint: "Отпечатва всички данъчни редове без таксата за услуга като един ред в сметката",
    useMenuTags: "Използвай етикети на менюто",
    billShowRoomName: "Покажи името на стаята вместо номера на стаята в сметката",
    askPinOnDeleteOrVoid: "Искайте ПИН при изтриване на изпратени поръчки или анулиране",
  },
  printerType: {
    printerName: "Име на принтер",
    paperWidth: "Ширина на хартията (мм)",
    paperHeight: "Височина на хартията (мм)",
    isSupportExternal: "Външна поддръжка",
  },
  utility: {
    maintenance: "В процес на поддръжка",
  },
  outlet: {
    taxDeclaration: "Декларация за данък",
    vatExemptionNote: "Бележка за освобождаване от ДДС",
    applyDiscountWithVATExemptionToOutletWithDisabledExemptVAT: "Не може да приложите отстъпка с освобождаване от ДДС, тъй като настройката 'Разреши освобождаване от ДДС' е изключена.",
    exemptUnexemptVAT: "Освободи / Не освобождавай от ДДС",
    exemptVAT: "Освободи от ДДС",
    unExemptVAT: "Не освобождавай от ДДС",
    noPriceSetup: "Няма зададена цена",
    noPriceAssignedToThisArticleOnCurrentWorkingDateContinue: "Няма зададена цена за тази стока за текущата работна дата. Да продължа ли?",
    cantAddArticleBecauseNoPriceAssignedToThisArticleOnCurrentWorkingDateAndAllowManualPriceIsSetToFalse: "Не може да добавите стока, защото няма зададена цена за тази стока за текущата работна дата и ръчното въвеждане на цена е изключено.",
    cantSelectSavedOrSentItemIfInGarnishMode: "Не можете да изберете елемент, който вече е изпратен или запазен, ако режимът на гарнитура е включен.",
    cantSetCourseStageOfChildWhileParentNotSelected: "Не може да се зададе етап на курс на детски елемент, докато родителят не е избран",
    processingOrder: "Обработка на поръчка",
    creatingQuickOrder: "Създаване на бърза поръчка",
    creatingOrder: "Създаване на поръчка",
    createOrder: "Създай поръчка",
    createOrderForX: "Създайте поръчка за резервация на маса с име на госта {x}",
    itemAlreadySaved: "Артикулът вече е запазен",
    itemAlreadySent: "Артикулът вече е изпратен",
    noItemToPay: "Няма елемент за плащане",
    failedToPrintTo: "Неуспешен печат на {x}",
    successToPrintTo: "Успешно печатане на {x}",
    captainOrderIminNotThisDevice: "{x} е вграден принтер на друго устройство, затова поръчката към кухнята не можа да бъде отпечатана там.",
    captainOrderM7NeedsAgent: "{x} е принтерен сървър на устройството без назначен агент. Назначете му агент, за да достигат поръчките към кухнята.",
    captainOrderIminNotConnected: "Няма връзка с вградения принтер на това устройство ({x}).",
    captainOrderIminStatusError: "Вграденият принтер на това устройство ({x}) докладва статус {status}, затова поръчката към кухнята не беше отпечатана.",
    retry: "Опитай отново",
    invalidPaymentMethod: "Невалиден метод на плащане",
    customerOrderX: "Поръчка на клиента {x}",
    pleaseSelectItemsToSend: "Моля, изберете артикул(и) за изпращане",
    itemsRemovedFromTheList: "Артикул(и) премахнати от списъка",
    missingInvoiceSeries: "Липсваща фактурна серия",
    cantChooseXForSplitPayment: "Не можете да изберете {x} за разделно плащане",
    amountToPay: "Сума за плащане",
    amountToPayCantBeGreaterThanRemainingPayment: "Сумата за плащане не може да е по-голяма от оставащото плащане",
    fireX: "Изпрати {x}",
    hold: "Дръж",
    setStage: "Настрой сцена",
    selectOutlet: "Изберете търговски обект",
    xPax: "{x} ЧОВЕКА",
    orderIDIsNotGenerated: "Идентификаторът на поръчката все още не е генериран",
    cantDeleteChildOfSentItem: "Не може да изтриете дете на изпратени елементи без да изтриете родителя му",
    cantDeleteSentOrderWhileOffline: "Не може да изтриете изпратена поръчка, когато сте офлайн",
    cancelOrderDocBillPrinterNotConfigured: "Документът за анулиране на поръчката не беше отпечатан: няма зададен подразбиращ се принтер за сметки за този обект.",
    labelPrinterNotConfigured: "Принтерът за етикети не е конфигуриран за тази точка на продажба. Задайте принтер за етикети в настройките на POS параметрите.",
    orderType: "Тип поръчка",
    dineIn: "Хранене на място",
    pickup: "Вземане",
    labelPrinter: "Принтер за етикети",
    alsoPrintStickyLabel: "Отпечатай и самозалепващите етикети",
    labelPrinterId: "ИД на принтер за етикети",
    printLabel: "Печат на етикет",
    noItemSelectedToPrintLabel: "Няма избрани артикули за печат на етикети.",
    labelOnlyForSentItems: "Етикети могат да се печатат само за изпратени артикули.",
    cantPrintLabelClosedOrder: "Не могат да се печатат етикети за затворена или анулирана поръчка.",
    cancelOrderDocOutletMissing: "Не може да се отпечата: избраните артикули нямат информация за обекта.",
    cancelOrderDocSingleOutletOnly: "Не може да се отпечата за няколко обекта — изберете артикули от един обект.",
    cancelOrderDocParameterNotFound: "Не може да се отпечата: POS параметърът на обекта не е намерен.",
    cancelOrderDocNotEnabledForOutlet: "Отпечатването на документ за анулиране не е активирано за този обект.",
    cantChangeQtySentItem: "Не може да промените количеството, защото поне един от избраните артикули вече е изпратен.",
    flavourCantAssignToChild: "Не може да зададете вкус на дочерен артикул.",
    flavourItemAlreadySent: "Артикулът вече е изпратен.",
    flavourNothingSelected: "Няма избран артикул за задаване на вкус.",
    flavourOnlySingleParent: "Вкус може да бъде зададен само на една родителска стока.",
    qtyChangeNoSelection: "Няма избрана стока или гарнитура за промяна на количеството.",
    qtyChangeMultipleSelection: "Избрани са повече от една стоки и/или гарнитури за промяна на количеството.",
    cantSendZeroPriceItems: "Не могат да се изпращат артикули с обща цена 0 или по-малко.",
    itemsAlreadySent: "Един или повече от избраните артикули вече са изпратени.",
    noPrinterOrScreenConfigured: "Няма конфигуриран принтер или екран за изпращане на тази поръчка.",
    parentNotSelectedForSend: "Не може да изпратите дочерен елемент, ако неговият родител не е избран.",
    cantSendOrderWhileOffline: "Не може да изпращате поръчка, когато сте офлайн.",
    packageMemberDiscountDisabled: "Не може да приложите отстъпка към артикули от пакет, защото тази опция е изключена в настройките на POS параметрите.",
    garnishNotApplicableForPackage: "Гарнитурата не е приложима за пакетни артикули.",
    ignoredSetStageForPackage: "Етапът не е приложим за пакетни артикули.",
    changePriceNotAllowedForPackage: "Промяната на цена не е разрешена за пакетни артикули.",
    cantModifySelectedTotalDiscount: "Не може да се промени избраната обща отстъпка.",
    discountTotal: "Отстъпка общо",
    noItem: "Няма елемент",
    allSavedItemsAlreadyHaveDiscountApplied: "Всички запазени артикули вече имат приложена отстъпка.",
    cantHaveMultipleDiscountTotal: "Не може да има няколко общи отстъпки.",
    maxDiscountToApply: "Макс. отстъпка за прилагане",
    cashReceived: "Получени пари",
    cashChange: "Промяна",
    outletType: "Тип обект",
    roomService: "Румсървис",
    noItemSelectedToAssignVAT: "Няма избран артикул за назначаване на освобождаване / неосвобождаване от ДДС",
    exemptVATCantBeAppliedToFlavour: "Освобождаването / неосвобождаването от ДДС не може да се приложи към вкус",
    unexemptVATForSelectedItem: "Това ще неосвободи ДДС за избрания артикул. Сигурни ли сте?",
    unexemptVATForXItems: "Това ще неосвободи ДДС за {x} избрани артикула. Сигурни ли сте?",
    mixedVATSelection: "Избрахте {x} артикул(и) без освобождаване от ДДС и {y} артикул(и), които вече са освободени. Изберете как да продължите.",
    discountAppliesToNonExemptOnly: "Отстъпката ще бъде приложена само към {x} артикул(и) без освобождаване от ДДС — {y} артикул(и), които вече са освободени, няма да бъдат променени.",
    discountSkippedLines: "Тези артикули няма да получат отстъпка и остават без промяна, защото ръчна отстъпка не е разрешена за тях: {items}",
    discountExemptProofsDiffer: "Избраните артикули имат различно доказателство за освобождаване от ДДС (различен PWD номер, номер на пенсионер или бележка). Отстъпка върху всички наведнъж би приложила доказателството на един артикул към всички, затова прилагайте отстъпката един по един.",
    quantityLimitExceeded: "{name}: Максималното количество продадено на ден ({limit}) е превишено. Остават {remaining}, моля прегледайте количеството.",
    failedToSendToPrinterOrScreen: "Неуспешно изпращане на поръчката до принтера или кухнята. Поръчката ще бъде запазена.",
  },
  discount: {
    amountIsBaseTaxAdded: "Въведената сума е базова сума. Данъкът и сервизната такса се начисляват отгоре, когато е приложимо, така че сумата, приспадната от общата сума, може да е по-голяма от въведената сума.",
    isExemptVAT: "Освободен от ДДС",
    exemptionProofType: "Доказателство за освобождаване от ДДС",
    useExemptionNote: "Използвай бележката",
    usePwdId: "Използвай ID на хора с увреждания",
    useSeniorCitizenId: "Използвай ID на пенсионер",
    pwdId: "ID на хора с увреждания",
    seniorCitizenId: "ID на пенсионер",
    pwdName: "Име на лице с увреждания",
    seniorCitizenName: "Име на пенсионер",
  },
  bill: {
    chosenPrinterIsAnotherDevicesHead: "Принтерът \"{printer}\" е вграденият принтер на друго устройство и не може да печата оттук. Изберете друг принтер в Настройки за печат на сметка.",
    vatRegNo: "ДДС регистрационен номер",
    minNo: "Мин. номер",
    snNo: "Сериен номер",
    check: "Чек",
    receiptNo: "Номер на разписка",
    guest: "Гост",
    date: "Дата",
    time: "Час",
    table: "Маса",
    waiter: "Сервитьор",
    preview: "ПРЕДВАРИТЕЛЕН ПРЕГЛЕД",
    copy: "КОПИЕ",
    original: "ОРИГИНАЛ",
    officialReceipt: "ОФИЦИАЛНА РАЗПИСКА",
    receipt: "РАЗПИСКА",
    amountWithVAT: "Сума с ДДС",
    lessVAT: "По-малко ДДС",
    amountWithoutVAT: "Сума без ДДС",
    subtotal: "Междинна сума",
    permitNo: "Номер на разрешително",
    accreditedNo: "Акредитиран номер",
    posSystemProvider: "Доставчик на POS система",
    tin: "ДДС номер (TIN)",
    issued: "Издадено на",
    billPreparedBy: "Сметката е подготвена от",
    billPrintedAt: "Сметката е отпечатана в",
    payment: "Плащане",
    paid: "Платено",
    change: "Ресто",
    name: "Име",
    guestName: "Име на госта",
    signature: "Подпис",
    roomNo: "Номер на стая",
    accountNo: "Номер на сметка",
    description: "Описание",
    qty: "Количество",
    price: "Цена",
    totalAmount: "Обща сума",
    amountCharged: "Начислена сума",
    taxDeclaration: "Декларация за данък",
    officialReceiptNote1: "Това служи като официална разписка ако",
    officialReceiptNote2: "е платено в брой и с кредитна карта",
    item: "Артикул",
    total: "Общо",
  },
  price: {
    currentBasePrice: "Текуща базова цена",
    currentPPVATSetupPrice: "Текуща цена по период на ДДС",
    currentAGOVATSetupPrice: "Текуща цена по група артикули и ДДС",
    currentExemptedVATSetupPrice: "Текуща цена с освободен ДДС",
    vatPriceSetupCode: "Код за настройка на цена с ДДС",
    vatAGOSetupCode: "Код за настройка на ДДС по група артикули",
    vatExemptedSetupCode: "Код за настройка на освободен ДДС",
    articleArticleGroupId: "ID на група артикули",
    changeWillBeAppliedToNPricePeriods: "Промените ще бъдат приложени за {n} ценови периода",
    batchUpdateWarningNote: "За да актуализирате ценовите данни, отметнете 'Актуализиране на цената' и въведете нова стойност. Попълнете другите полета, ако е необходимо. Оставете полето празно, за да запазите текущата стойност.",
    showOnFbMenu: "Покажи в менюто на FB",
    batchShowOnFbMenu: "Видимост на FB менюто",
    bulkShowOnFbMenu: "Покажи в QR менюто",
    bulkHideFromFbMenu: "Скрий от QR менюто",
    subRecipe: "Подрецепта",
    addSubRecipe: "Добави подрецепта",
  },
  generalSetup: {
    printDeletedSentOrder: "Отпечатай изтритите изпратени поръчки",
    showNFCIconInToolbar: "Покажи иконата на NFC в лентата с инструменти",
    showQuickOrderIconInToolbar: "Покажи икона за бърза поръчка в лентата с инструменти",
    showQuickOrderInMenu: "Покажи бърза поръчка в менюто",
    hideTableNumberInTableList: "Скрий номер на масата в списъка",
    showValidityAcknowledgmentCertificateStatement: "Покажи декларация за валидност на удостоверение",
    billCopyWording: "Копие на фактура",
    customerTaxIdentifierText: "Идентификатор на данъка на клиента (по подразбиране 'ПИН на клиента')",
    sendOrderToScreens: "Изпрати поръчка към екраните",
    systemInfo: "Информация за системата",
    systemName: "Име на системата",
    systemVatRegTin: "ДДС рег. № на системата (VAT REG TIN)",
    vatRegTin: "ДДС рег. № (VAT REG TIN)",
    systemAccrNo: "Акред. № на системата",
    accrNo: "Акред. №",
    dateIssued: "Дата на издаване",
    validUntil: "Валидно до",
    systemAccrIssuedDate: "Дата на издаване на акредитация на системата",
    systemAccrValidUntil: "Акредитация на системата валидна до",
    systemPtuNo: "PTU № на системата",
    ptuNo: "PTU №",
    systemAddress: "Адрес на системата",
    systemPtuIssuedDate: "Дата на издаване на PTU на системата",
    useMenuTags: "Използвай тагове на менюто",
  },
  faq: {
    call: "Имате други въпроси? Моля, свържете се с нас ",
  },
  ecommerce: {
    products: "Продукти",
    filters: "Филтри",
    collections: "Колекции",
    priceRange: "Ценови диапазон",
    customerReviews: "Отзиви на клиенти",
    up: "и нагоре",
    brand: "Марка",
    search: "Търсене на продукт",
    results: "Резултати ( {0} от {1} )",
    orders: "Поръчки",
    shipping: "Доставка",
    freeShipping: "Безплатна доставка",
    inStock: "В наличност",
    quantity: "Количество",
    addToCart: "Добави в количката",
    buyNow: "Купи сега",
    price: "Цена",
    about: "За този артикул",
    description: "Описание",
    reviews: "Отзиви",
    details: "Детайли за продукта",
    cart: "Количка",
    summary: "Обобщение на поръчката",
    total: "Общо",
    discount: "Отстъпка",
    subtotal: "Междинна сума",
    continue: "Продължи с пазаруването",
    checkout: "Плащане",
  },
  menu: {
    rateManagement: "Управление на тарифи",
    reservation: "Резервация",
    reservationNew: "Нова",
    reservationList: "Списък",
    frontOffice: "Фронт офис",
    generalSettings: "Общи настройки",
    guestTitle: "Заглавие на госта",
    guestDocumentType: "Тип документ на госта",
    manageHotel: "Хотел",
    hotel: "Хотел",
    hotelList: "Списък",
    hotelCategory: "Категория хотел",
    hotelChain: "Хотелска верига",
    marketSegment: "Пазарен сегмент",
    rooms: "Стаи",
    currency: "Валута",
    search: "Търсене (натиснете \"ctrl + /\" за фокус)",
    dashboard: "Табло",
    logout: "Изход",
    profile: "Профил",
    blank: "Празна страница",
    pages: "Страници",
    others: "Други",
    email: "Имейл",
    chat: "Чат",
    todo: "Задачи",
    board: "Дъска със задачи",
    users: "Потребители",
    usersList: "Списък",
    usersEdit: "Редакция",
    ecommerce: "Електронна търговия",
    ecommerceList: "Продукти",
    ecommerceProductDetails: "Детайли за продукта",
    ecommerceOrders: "Поръчки",
    ecommerceCart: "Количка",
    auth: "Страници за удостоверяване",
    authLogin: "Вход / Регистрация",
    authRegister: "Регистрация",
    authVerify: "Потвърди имейл",
    authForgot: "Забравена парола",
    authReset: "Нулиране на парола",
    errorPages: "Страници за грешки",
    errorNotFound: "Не е намерено / 404",
    errorUnexpected: "Неочаквана / 500",
    utilityPages: "Помощни страници",
    utilityMaintenance: "В процес на поддръжка",
    utilitySoon: "Очаквайте скоро",
    utilityHelp: "ЧЗВ / Помощ",
    levels: "Нива на менюто",
    disabled: "Менюто е деактивирано",
    docs: "Документация",
    feedback: "Обратна връзка",
    support: "Поддръжка",
    tables: "Таблици",
    orderHistories: "История на поръчките",
    all: "Всички",
    closed: "Затворено",
    open: "Отворено",
    deletedSentOrders: "Изтрити изпратени поръчки",
    deletedOrderPayments: "Изтрити плащания по поръчки",
    transferOrderHistory: "История на прехвърляне на поръчки",
    closedDays: "Затворени дни",
    screens: "Екрани",
    masterData: "Основни данни",
    outlet: "Обект",
    generalSetup: "Общи настройки",
    parameter: "Параметър",
    table: "Таблица",
    articleProductType: "Тип продукт на артикул",
    article: "Артикул",
    articleGroup: "Група артикули",
    articleGroupSetup: "Настройка на група артикули",
    articleGroupOutletSetup: "Настройка на група артикули за обект",
    articleFlavourGroup: "Група вкусове на артикул",
    articleFlavour: "Вкус на артикул",
    articleFlavourGroupArticleGroupSetup: "Настройка на група вкусове на група артикули",
    collectionCategory: "Категория колекция",
    collectionType: "Тип колекция",
    collectionIdentificationGroup: "Група идентификация на колекция",
    collectionIdentification: "Идентификация на колекция",
    collectionTypeOutletSetup: "Настройка на тип колекция за обект",
    price: "Цена",
    discount: "Отстъпка",
    printer: "Принтер",
    screen: "Екран",
    agent: "Агент",
    banquet: "Банкет",
    banquetGroupList: "Списък на банкетни групи",
    banquetReservationList: "Списък на банкетни резервации",
    banquetReservationCalendar: "Календар на банкетни резервации",
    reports: "Доклади",
    masterAccount: "Главна сметка",
    incomeAudit: "Одит на приходите",
    outletStatus: "Статус на обекта",
    manageNfcBracelet: "Управление на NFC гривна",
    taxInterfaceIntegrationLog: "Дневник на интеграция с данъчния интерфейс",
    workingDay: "Работен ден",
    index: "Индекс",
    printerType: "Тип на принтер",
    flushSiteData: "Изчисти данни на сайта",
    quickOrder: "Бърза поръчка",
    mealTimeSetup: "Настройка на време за хранене",
    tableReservation: "Резервация на маса",
    breakfastRegistration: "Регистрация за закуска",
    mealRegistration: "Регистрация на ястие",
    roomBreakfastRegistration: "Регистрация за закуска в стаята",
    roomLunchRegistration: "Регистрация за обяд в стаята",
    roomDinnerRegistration: "Регистрация за вечеря в стаята",
    banquetLunchRegistration: "Регистрация за обяд на банкета",
    banquetDinnerRegistration: "Регистрация за банкетна вечеря",
    itemLoan: "Заем на артикул",
    courseStage: "Етап на курса",
    intercompanyMapping: "Междусистемно картографиране",
    fbMenuOrderRequest: "Заявка за поръчка от F&B меню",
    fbMenuConfiguration: "Конфигурация на F&B менюто",
    guestProfiles: "Профили на гости",
    tableLabelManagement: "Управление на етикетите на масите",
    package: "Пакет",
    maintenanceRequest: "Заявка за поддръжка",
    waiter: "Сервитьор",
    captainOrder: "Заповед на капитана",
    workingDate: "Работна дата",
  },
  localCommon: {
    dimensionSetup: "Настройка на измерения",
    dimensionSetupSaved: "Настройката на измерения е запазена успешно!",
    dimensionSetupDeleted: "Настройката на измерения е изтрита успешно!",
    dashboardWithItem: "Табло {item}",
    top10ItemsSoldWithItem: "Топ 10 продадени артикула - {item}",
    roomRevenueBreakdown: "Разбивка на приходите от стаи",
    inHouseList: "Списък на настанените",
    openDay: "Отвори деня",
    closeDay: "Затвори деня",
    to: "до",
    hostURLIPAddress: "URL на хоста / IP адрес",
    unknown: "Неизвестно",
    customDate: "Персонализирана дата",
    itemLoan: "Заем на артикул",
    maintenanceRequestReport: "Доклад за искане на поддръжка",
    printCancellationDocument: "Отпечатай документ за анулиране",
    allowOverLimit: "Позволи над лимита",
    allowOverLimitDesc: "Ако е активирано, транзакциите могат да надвишат наличния баланс.",
    allowOverLimitWarning: "Транзакциите, които надвишават лимита, ще бъдат обработени и системата ще покаже известие за надвишаване на лимита.",
    collectionIdentification: "Идентификация на колекция",
    continue: "Продължи",
    creditBalanceAmount: "Сума по кредит",
    creditBalanceAmountDesc: "Максимален лимит за използване на месец.",
    creditBalancePositive: "Сумата на кредитния баланс трябва да е по-голяма от нула",
    critical: "Критичен",
    currentBalance: "Текущо салдо",
    currentBalanceDesc: "Оставащ лимит, който все още е наличен през текущия месец (изчислено от системата).",
    limitExhausted: "Лимит изчерпан",
    monthlyCreditLimit: "Месечен кредитен лимит",
    monthlyCreditLimitSubtitle: "Лимитът се прилага за текущия месец въз основа на осчетоводените транзакции.",
    nearLimit: "Близо до лимита",
    normal: "Нормален",
    ok: "Добре",
    overLimit: "Над лимита",
    totalUsedBalance: "Обща използвана сума",
    totalUsedBalanceDesc: "Общо използване през текущия месец (изчислено от системата).",
    warning: "Предупреждение",
  },
  button: {
    add: "Добави",
  },
  collectionType: {
    oneCollectionTypePerCategoryPerOutlet: "Моля, уверете се, че всеки обект има поне един тип колекция за всяка категория колекция. За категорията BRACELET, всеки обект трябва да има точно един тип колекция",
  },
  localColumns: {
    dimensionCode: "Код на измерение",
    dimensionName: "Име на измерение",
    dimensionValueCode: "Код на стойност на измерение",
    dimensionValueName: "Име на стойност на измерение",
    expenseDimensions: "Измерения на разхода",
    costDimensions: "Измерения на себестойността",
    topProduct: "Топ продукт",
    hour: "Час",
    salesRevenue: "Приходи от продажби",
    transactions: "Транзакции",
    averageTransactions: "Среден брой транзакции",
    averageSales: "Средни продажби",
    quantitySold: "Продадено количество",
    averagePrice: "Средна цена",
    totalOrders: "Общ брой поръчки",
    totalSales: "Общи продажби",
    averageOrderAmount: "Средна сума на поръчка",
    topProductName: "Име на топ продукт",
    topProductRevenue: "Приходи от топ продукт",
    averageBillSize: "Среден размер на сметка",
    topBeverageArticle: "Топ напитка",
    topFoodArticle: "Топ храна",
    currentStock: "Текуща наличност",
    costPerUnit: "Цена на единица",
    last30DaysSalesQuantity: "Продадено количество за последните 30 дни",
    daysUntilOutOfStock: "Дни до изчерпване на наличността",
    averageDaysPerOrder: "Среден брой дни на поръчка",
    revenuePercentage: "Процент на приходите",
    discountDescription: "Описание на отстъпката",
    discountCount: "Брой отстъпки",
    totalDiscountAmount: "Обща сума на отстъпките",
    reOrderLevel: "Ниво за повторна поръчка",
    totalRevenueExcludingTax: "Обща приходи без данък",
    articleGroupName: "Име на група артикули",
    creditBalanceAmount: "Салдо по кредит",
    totalUsedBalance: "Обща използвана наличност",
    currentBalance: "Текущо салдо",
    allowOverLimit: "Позволи над лимита",
    foodRevenue: "Приходи от храна",
    beverageRevenue: "Приходи от напитки",
    costAccount: "Сметка за разходи",
  },
  guestProfile: {
    guestProfile: "Профил на гост",
    successCreate: "Профилът на госта беше създаден успешно!",
    successUpdate: "Профилът на госта беше актуализиран успешно!",
    membership: "Членство",
    membershipNumber: "Номер на членство",
    cityNotes: "Въведете поне 3 знака, за да намерите град.",
    membershipType: "Тип членство",
    customerPIN: "ПИН на клиента",
    copyGuestFromFO: "Копиране на профил на гост от FO?",
    successCopy: "Профилът на госта е копиран успешно",
    copyGuestProfile: "Копиране на профил на гост",
    editGuestProfile: "Редактиране на профил на гост",
    seeFOGuestList: "Виж списъка с гости на рецепция",
    foGuestList: "Списък с гости на рецепция",
    saveGuestName: "Запази името на профила на госта",
    posGuestProfile: "Профил на госта в POS",
    saveGuestProfileNameConfirmation: "Това ще актуализира името на избрания профил на гост, сигурни ли сте?",
    tinNumber: "Данъчен идентификационен номер",
    scIdNumber: "Номер на карта на пенсионер",
    pwdIdNumber: "Номер на карта за хора с увреждания",
    signatureName: "Име за подпис",
    isMembership: "Членство",
  },
  payment: {
    paymentTab: "Плащане",
    tipTab: "Бакшиш",
    tips: "Бакшиши",
    tipType: "Тип",
    tipDescription: "Описание",
    tipAmount: "Сума на бакшиша",
    totalTip: "Общо бакшиш",
    noTips: "-- Няма бакшиши --",
    addTip: "Добави бакшиш",
    tipAmountMustBePositive: "Сумата на бакшиша трябва да е по-голяма от нула",
    cardNumber: "Номер на картата",
    cardName: "Име на картата",
    cardExpirationDate: "Срок на валидност на картата",
    cardTraceNumber: "Номер на транзакцията",
    cardExpired: "Картата е с изтекъл срок",
    invoiceAmountRemaining: "Оставаща сума по фактурата",
    userPayment: "Плащане от потребителя",
    amountToPay: "Сума за плащане",
    change: "Ресто",
    remainingPayment: "Оставащо плащане",
    titleHere: "Заглавие тук",
    amountToPayGreaterThanUserPayment: "Сумата за плащане не може да е по-голяма от потребителското плащане",
    amountToPayGreaterThanRemainingPayment: "Сумата за плащане не може да е по-голяма от оставащото плащане",
    cantCombinePayment: "Не можете да комбинирате {payment} с друг вид плащане",
    totalPaymentEqualInvoiceAmount: "Общото плащане вече е равно на сумата по фактурата. Премахнете плащания, за да изберете друг метод.",
    paymentIsNotReady: "Функцията за плащане не е готова!",
    notAllowedToLedger: "{payment} не е позволено в счетоводната книга",
    disabled: "{payment} е деактивирано",
    ledger: "Счетоводна книга",
    insufficientCredit: "Недостатъчен кредит за плащане",
    differentClientPostingGroup: "Различна група за публикуване на клиенти с клиент",
    ledgerForm: "Форма на главна книга",
    manualOrNumber: "Ръчно въвеждане или номер",
    manualOrNumberRequired: "Ръчното въвеждане или номерът е задължителен за плащания в брой или с карта.",
    failedToSaveManualOrNumber: "Неуспешно запазване на ръчното въвеждане или номера. Моля, опитайте отново.",
    failedToPay: "Неуспешно обработване на плащането. Поръчката е запазена, но сметката не е платена. Моля, опитайте отново.",
    availableBalance: "Наличен баланс",
    collectionLimitExceededMessage: "Тази плащане надвишава наличния месечен кредитен лимит за избраната Идентификация на Колекция. Моля, използвайте друга Идентификация на Колекция с наличен баланс или помолете администратор да коригира сумата на кредитния баланс.",
    collectionLimitExceededTitle: "Надвишен лимит за идентификация на колекцията",
    creditLimit: "Кредитен лимит",
    invoiceAmount: "Сума по фактурата",
    overLimitAmount: "Над лимит",
    overLimitProcessedMessage: "Транзакцията е обработена със сума над лимита {amount}",
    overLimitWarningMessage: "Тази плащане ще надвиши наличния месечен кредитен лимит за избраната идентификация на колекцията.",
    overLimitWarningTitle: "Предупреждение за надвишаване на лимита",
    usedThisMonth: "Използвано този месец",
  },
  dashboard: {
    activity: "Дейност",
    weeklySales: "Седмични продажби",
    sales: "Продажби",
    recentOrders: "Последни поръчки",
    sources: "Източници на трафик",
    lastweek: "срещу миналата седмица",
    orders: "Поръчки",
    customers: "Клиенти",
    tickets: "Поддръжка",
    viewReport: "Преглед на доклада",
    totalPaidOrders: "Общо платени поръчки",
    totalAmount: "Обща сума",
    totalTaxes: "Общо данъци",
    grandTotal: "Обща сума",
    totalQty: "Обща колич.",
    totalGuests: "Общо гости",
    totalQuickOrders: "Общо бързи поръчки",
    foodTotalAmount: "Обща стойност на храната",
    foodTotalQty: "Общо количество храна",
    beverageTotalAmount: "Обща сума на напитките",
    beverageTotalQty: "Обща количество напитки",
    othersTotalAmount: "Обща сума на другите",
    othersTotalQty: "Общо количество на другите",
    tobaccoTotalAmount: "Обща сума тютюн",
    tobaccoTotalQty: "Обща количество тютюн",
    totalCovers: "Общо покрития (Обслужени гости)",
    averageSpendPerGuest: "Средни разходи на гост",
    averageTransactionValue: "Средна стойност на транзакцията",
    assumedTableTurnTime: "Предполагаемо време за смяна на маса",
    averageTableTurnTime: "Средно време за обръщане на маса",
    seatingCapacity: "Капацитет на седалки",
    totalItemsSold: "Общо продадени артикули",
    totalTransactions: "Общо транзакции",
    summaryMetrics: "Обобщени метрики",
    potentialCoversPerMealtime: "Възможни покрития на хранене",
    serviceCharge: "Такса за услуга ({percent}% от приходите)",
    vatRevenue: "ДДС ({percent}% от приходите)",
    netSales: "Нетни продажби (без данък и такса)",
    dateRangeTo: "Период: {s} до {e}",
    topThreeItemsSold: "Топ три продадени артикула",
    topDiscounts: "Най-добри отстъпки",
    outletHours: "Работно време на магазина:",
    breakfast: "Закуска",
    lunch: "Обяд",
    dinner: "Вечеря",
    allDayDining: "Целодневно хранене",
    potentialCoversPerMealTimeDesc: "{potential_cover_per_mealtime} покрития ({seating_capacity} места x {potential_turns_per_mealtime} оборота)",
    occupancyRateDesc: "{occupancy_rate} % ({total_covers} гости / {total_seats} места x {potential_turns_per_mealtime} потенциални обороти за {days_config} дни)",
    mealTime: "Време за храна",
    allRevenueExcludingComplimentary: "Всички приходи, без безплатни артикули.",
    complimentaryExcluded: "Безплатно Изключено",
    allRevenueAllDayIncludeComplimentary: "Всички приходи са от целодневно хранене и включват безплатни услуги.",
    totalItemIncludingComplimentaryItems: "Общо артикули, включително безплатни",
    totalTransactionsIncludingComplimentary: "Общо транзакции, включително безплатни",
    totalBaseAmountExcludingComplimentaryItems: "Обща основна сума без безплатни артикули",
    totalCoversNumberOfGuestIncludingComplimentary: "Общо покрития (брой гости) с включени безплатни",
    averageSpendPerGuestExcludingComplimentaryItemsOrServices: "Среден разход на гост, без безплатни артикули или услуги.",
    averageTransactionValueExcludingComplimentaryItemsOrServices: "Средна стойност на транзакцията, без безплатни артикули или услуги.",
    averageTableTurnoverTimeComplimentaryExcluded: "Средно време за оборот на маса, без безплатни",
    percentageOfAvailableSeatCapacityUsedByGuests: "Процент от наличната капацитет на места, който е бил действително използван от гостите",
    totalOrdersIncludeComplimentary: "Общите поръчки включват безплатни.",
    totalPaidOrdersIncludeComplimentary: "Общите платени поръчки включват безплатни.",
    clickForDetailsBreakdown: "Кликнете за подробности",
    totalNumberOfSeatsAvailableForGuests: "Общ брой налични места за гости",
    percentageOfAvailableSeatCapacityActuallyUsedByGuests: "Процент от наличната капацитет на местата, използван от гостите",
    totalServiceChargeExcludingComplimentaryItems: "Обща такса за услуга, без безплатни артикули",
    totalVatRevenueExcludingComplimentaryItems: "Обща ДДС приходи, без безплатни артикули",
    totalNetSalesExcludingComplimentaryItems: "Общо нетни продажби, без безплатни артикули",
    totalTaxesExcludingComplimentaryItems: "Общо данъци, без безплатни артикули",
    totalNetSalesIncludingComplimentaryItems: "Общо нетни продажби, включително безплатни артикули",
    totalAmountExcludingComplimentaryItems: "Обща сума, без безплатни артикули",
    applyFilter: "Приложи филтър",
  },
  printer: {
    identifyThisDeviceAsX: "Идентифицирай това устройство като {x}",
    unassignThisDeviceFromX: "Премахни това устройство от {x}",
    overrideAndAssignThisDeviceAsX: "Замести зададеното устройство и зададете това устройство като {x}",
    thisDeviceIsX: "Т устройството е {x}",
    testPrint: "Тестово печатане",
    testPrintContent: "Тестово съдържание",
    testPrintSettings: "Настройки за печат",
    sendTestPrint: "Изпрати тестов печат",
    resetToDefault: "Върни по подразбиране",
    testPrintSent: "Изпратен тестов печат",
    testPrintFailed: "Неуспешен тестов печат",
    testPrintNoAgent: "Не е конфигуриран SentecAgent хост или URL на принтер за този принтер",
  },
  intercompanyMapping: {
    sourceHotel: "Източник Хотел",
    targetHotel: "Целеви хотел",
    sourceArticle: "Източник на статията",
    targetArticle: "Целеви артикул",
    sourceArticleGroup: "Група източни статии",
    targetArticleGroup: "Целева група статии",
    asSource: "Като източник",
    asTarget: "Като цел",
    mapping: "Картографиране",
    intercompanyArticleMapping: "Картографиране на статии между компании",
    intercompanyArticleGroupMapping: "Картографиране на групи артикули между компании",
    checkTargetOutletStatus: "Междупредприятелско картографиране: Проверка на статус на целевия обект",
    createIntercompanyMappingEntries: "Междусистемно картографиране: Създайте записи за междусистемно картографиране",
    productTypesToTransfer: "Видове продукти за прехвърляне",
    defaultPayment: "Целеви стандартен платеж",
    defaultComplimentaryPayment: "Целева подразбираща се комплиментарна плащане",
    defaultCollectionIdentification: "Целева подразбираща се идентификация на събирането",
    defaultOutlet: "Целеви стандартен изход",
    defaultTable: "Целева таблица по подразбиране",
    sourceOutlet: "Изходен източник",
    sourceArticleProductType: "Тип продукт на източната статия",
    prefix: "Целеви префикс",
    checkSourceOutletStatus: "Междуфирмено съпоставяне: Проверка на статуса на изходния обект",
  },
  articleGroupOutlet: {
    saveArticleGroupOutletBeforeAddingRevenueCenterMealTime: "Моля, запазете настройките на групата статии преди да добавите център за приходи за време на хранене.",
    confirmRevenueCenterInternalUserChange: "Това действие ще актуализира настройката на приходния център за избраната група статии/обект. Съществуващите транзакции, свързани с тази група, няма да попречат на промяната. Искате ли да продължите?",
    confirmVATPostingGroupInternalUserChange: "Това действие ще актуализира групата за осчетоводяване на ДДС за избраната група статии/обект. Съществуващите транзакции, свързани с тази група, няма да попречат на промяната. Искате ли да продължите?",
    exemptedVATPostingGroup: "Група за осчетоводяване на освободено ДДС",
  },
  tableReservation: {
    seats: "Места",
    cantReserveForDateBeforeTodayWorkingDate: "Не можете да резервирате за дата преди днешната работна дата",
    tableReservedFromXtoY: "Масата е резервирана за {x} до {y}",
    cantEditCompleted: "Не можете да редактирате завършена резервация на маса",
    cantCancelCompleted: "Не може да отмените завършена резервация на маса",
    cantDeleteCompleted: "Не може да се изтрие завършена резервация на маса",
    cantEditCanceled: "Не може да се редактира отменена резервация на маса",
    cantCancelCanceled: "Не може да отмените отменена резервация на маса",
  },
  breakfastRegistration: {
    breakfastRegistration: "Регистрация за закуска",
    outletClosed: "Изходът е затворен",
    noGuest: "Няма гост",
    allGuestRegistered: "Всички гости вече са регистрирани за тази стая",
    selectedGuestAlreadyRegistered: "Избраният гост вече е регистриран",
    readingCard: "Четене на карта",
    guestRegistered: "Регистриран гост",
    readCard: "Прочетете карта",
    registerGuest: "Регистрация на гост",
    undoRegisterGuest: "Отмени Регистрация на Гост",
    chooseGuestToUnregister: "Моля, изберете гост за отписване",
    cantUnregisterWhosNotRegistered: "Не може да се анулира регистрацията на непознат, който не е регистриран.",
    roomNotFoundInList: "Стаята не е намерена в списъка.",
  },
  mealRegistration: {
    totalExpected: "Обща очаквана",
    totalActual: "Общо реално",
    totalVariance: "Обща разлика",
    totalBanquetReservation: "Обща резервация за банкет",
    undoRegister: "Отмяна на регистрация",
    numberOfGuest: "Брой гости",
    expected: "Очаквано",
    actual: "Действителен",
    cardOutsideBanquetWindow: "{status}: Guest stay ({guestCheckIn} - {guestCheckOut}) is outside banquet time ({banquetStart} - {banquetEnd}).",
  },
  reports: {
    includeComplimentary: "Включи безплатно",
    showVATBreakdown: "Покажи ДДС Разбивка",
    posSalesByHour: "Продажби по час",
    posSalesByHourReport: "Доклад за продажбите по час",
    posSalesByCategory: "Продажби по категория в ПОС",
    posSalesByCategoryReport: "Доклад за продажби по категория в POS",
    posInventoryAndStock: "Инвентар и наличности на ПОС",
    posInventoryAndStockReport: "Отчет за инвентаризация и наличности",
    salesPerfomanceAndAnalysis: "Продажби и анализи",
    hospitalityAndServiceInteraction: "Хотелско обслужване и взаимодействие",
    transactionAndCashierManagement: "Управление на транзакции и касиери",
    inventoryAndOperationalManagement: "Управление на инвентар и операции",
    bottomSalesByArticleReport: "Доклад за най-слабо продаваните артикули",
    posBottomSalesByArticle: "Доклад за продажби по артикул на POS",
    reportName: "Име на доклада",
    salesPerformanceAndAnalysis: "Производителност и анализ на продажбите",
    showAllTime: "Покажи цялото време",
    paymentTotal: "Общо плащания",
    totalIncludingTips: "Общо с бакшиши",
    zReport: "Z отчет",
    xReport: "X отчет",
    cashier: "Касиер",
    posSalesByTableLabelReport: "Отчет за продажби на ПОС по етикет на маса",
    posSalesByTableLabel: "Доклад за продажби по маси",
    salesSummaryByPackageReport: "Резюме на продажбите по пакет",
    packageCode: "Код на пакета",
    packageName: "Име на пакета",
    packageRevenue: "Приходи от пакет",
    packageQuantity: "Количество в пакет",
    avgPackagePrice: "Средна цена на пакета",
    topPackage: "Върховен пакет",
    numberOfPackages: "Брой пакети",
    averagePrice: "Средна цена",
    contributionPct: "% Принос",
    contributionPctFromTotalRevenue: "Процент принос от общия приход",
    packageBreakdown: "Разбивка на пакета",
    posProductionByWaiter: "Производство на ПОС от сервитьор",
    posProductionByWaiterReport: "Доклад за производство на ПОС от сервитьор",
    reportType: "Тип отчет",
    asOfDate: "Дата на отчитане",
    customRange: "Персонализиран диапазон",
    quickSelect: "Бърз избор",
    waiterCode: "Сервитьор",
    waiters: "Сервитьори",
    productionBreakdownFor: "Разпределение на продукцията за {waiter} ({period})",
    unassigned: "Несъответстващ",
    birSCDiscountReport: "Доклад за отстъпка за възрастни хора BIR",
    birPWDDiscountReport: "Доклад за отстъпка BIR PWD",
    showFnbRevenue: "Покажи приходи от храни и напитки",
    printPdfLandscape: "Печат на PDF в пейзажен режим",
    showScPwdNames: "Покажи имена на пенсионери/ХН",
    creditMemoVoidReport: "Доклад за кредитни известия / анулирания",
    documentType: "Вид документ",
    documentTypeCreditMemo: "Кредитно известие",
    documentTypeVoid: "Анулиране",
    documentTypeBoth: "И двете",
    type: "Тип",
    originalInvoiceNo: "Номер на оригиналната фактура",
    originalWorkingDate: "Оригинална работна дата",
    voidReason: "Причина за анулиране",
  },
  taxIntegrationLog: {
    decodeDocumentPayloadIntoJSON: "Декодирай полезен товар на документа в JSON",
  },
  screen: {
    new: "Нова",
    inProgress: "В подготовка",
    ready: "Готово за сервиране",
    done: "Сервирано",
    table: "Маса",
    orderNumber: "Поръчка №",
    sentBy: "Изпратено от",
    sinceOrderWasSent: "{minute} минута откакто поръчката беше изпратена | {minute} минути откакто поръчката беше изпратена",
    todaysFinishedOrders: "Завършени поръчки за днес",
    posScreenOrdersReport: "Отчет за поръчките на POS екрана",
    captainOrder: "Captain Order",
    printer: "Принтер",
    action: "Действие",
    reprintQuestion: "Повторен печат?",
    reprint: "Повторен печат",
    lastPrinted: "Последно отпечатано",
    batch: "Партида",
    search: "Търсене",
    reprintAll: "Всички",
    reprintYes: "Да",
    reprintNo: "Не",
    popupBlocked: "Изскачащият прозорец беше блокиран. Разрешете изскачащи прозорци за този сайт, за да отпечатате.",
    coReprint: "CO Повторен печат {count}",
    markAllReady: "Маркирай всички като готови",
    markSelectedReady: "Маркирай избраните като готови ({count})",
  },
  articleProductType: {
    discountRevenueCenter: "Център за отстъпки",
    perLineDiscountsWillUseTheSelectedRevenueCenter: "Отстъпките на ред ще използват избрания приходен център.",
    toEnableThisFeatureMakeSureDiscountAndAllowanceActiveInPOSParameter: "За да активирате тази функция, уверете се, че са активирани Отстъпки и Допуски в параметрите на ПОС.",
  },
  contactPerson: {
    contactPerson: "Лице за контакт",
    successCreate: "Лице за контактът е създадено успешно.",
  },
  agency: {
    successCreate: "Агенцията е създадена успешно.",
    successUpdate: "Агенцията беше актуализирана успешно.",
  },
  client: {
    successCreate: "Клиентът е създаден успешно.",
    successUpdate: "Клиентът беше актуализиран успешно.",
  },
  clientComposition: {
    successCreate: "Клиентската композиция е създадена успешно.",
    successUpdate: "Състав на клиента успешно обновен.",
    warningChangeIsLedgerAllowed: "Нужни са права за промяна на „Разрешен ли е Ledger“",
    noLimit: "Без лимит",
    setLimit: "Задайте лимит",
    currentAging: "Текущ баланс на стареене",
    todayLedger: "Днешна книга",
    totalUsedBalance: "Общ използван баланс",
    availableCredit: "Наличен кредит",
  },
  $vuetify: {
    badge: "Значка",
    close: "Затвори",
    loading: "Зареждане...",
    dataIterator: {
      noResultsText: "Няма намерени съвпадащи записи",
      loadingText: "Зареждане на елементи...",
    },
    dataTable: {
      itemsPerPageText: "Редове на страница:",
      ariaLabel: {
        sortDescending: "Сортирано низходящо.",
        sortAscending: "Сортирано възходящо.",
        sortNone: "Не е сортирано.",
        activateNone: "Активирай за премахване на сортирането.",
        activateDescending: "Активирай за сортиране низходящо.",
        activateAscending: "Активирай за сортиране възходящо.",
      },
      sortBy: "Сортирай по",
    },
    dataFooter: {
      itemsPerPageText: "Елементи на страница:",
      itemsPerPageAll: "Всички",
      nextPage: "Следваща страница",
      prevPage: "Предишна страница",
      firstPage: "Първа страница",
      lastPage: "Последна страница",
      pageText: "{0}-{1} от {2}",
    },
    datePicker: {
      itemsSelected: "{0} избрани",
      nextMonthAriaLabel: "Следващ месец",
      nextYearAriaLabel: "Следваща година",
      prevMonthAriaLabel: "Предишен месец",
      prevYearAriaLabel: "Предишна година",
    },
    noDataText: "Няма налични данни",
    carousel: {
      prev: "Предишна визуализация",
      next: "Следваща визуализация",
      ariaLabel: {
        delimiter: "Слайд {0} от {1}",
      },
    },
    calendar: {
      moreEvents: "Още {0}",
    },
    fileInput: {
      counter: "{0} файла",
      counterSize: "{0} файла ({1} общо)",
    },
    timePicker: {
      am: "AM",
      pm: "PM",
    },
    pagination: {
      ariaLabel: {
        wrapper: "Навигация за странициране",
        next: "Следваща страница",
        previous: "Предишна страница",
        page: "Към страница {0}",
        currentPage: "Текуща страница, страница {0}",
      },
    },
    input: {
      clear: "Изчисти",
      prependAction: "{0} предходно действие",
      appendAction: "{0} приложено действие",
    },
  },
  fbMenuConfiguration: {
    title: "Конфигурация на F&B менюто",
  },
  fbMenuOrderRequest: {
    def: "Заявка за поръчка от менюто на FB",
    open: "Отворете заявките за поръчка от менюто на F&B",
    closed: "Затворена заявка за поръчка от менюто на F&B",
    all: "Всички заявки за поръчка от менюто на F&B",
    chooseTable: "Изберете маса",
    orderCreatedFromRequest: "Поръчка създадена от заявка за меню F&B",
    posMenuQRCode: "QR код на менюто за храни и напитки в POS",
    guestRoomTable: "Таблица за стая на госта",
    assignTable: "Назначи маса",
    currentlyOccupiedByGuestName: "в момента зает от Име на госта",
    confirmOrderCancelTitle: "Отмяна на поръчка",
    confirmOrderCancelBody: "Сигурни ли сте, че искате да отмените поръчката?",
    confirmUndoOrderCancelTitle: "Отмяна на анулирана поръчка",
    confirmUndoOrderCancelBody: "Сигурни ли сте, че искате да отмените поръчката?",
    orderHasBeenCancelled: "Поръчката е отменена",
    orderHasBeenUndoCancel: "Поръчката е възстановена",
    auditLog: {
      title: "Одит Лог",
      guest: "Гост",
      columns: {
        created: "Кога",
        type: "Действие",
        createdBy: "От",
        description: "Описание",
      },
      types: {
        CREATE: "Поръчка Създадена",
        ASSIGN_TABLE: "Маса Назначена",
        CANCEL_BY_ADMIN: "Отказано от Админ",
        UNDO_CANCEL: "Отказването Възстановено",
      },
    },
    guestQR: "QR за гости",
    guestQRHint: "Покажете това на вашия гост. Сканирането им позволява да поръчат от тази маса директно в сметката.",
    guestQRPrintPopupBlocked: "Изскачащото меню е блокирано. Разрешете изскачащи прозорци за този сайт, за да отпечатате QR.",
    guestQRPrintFailed: "Не можа да подготви QR за печат.",
    scanMeToOrder: "Сканирай ме, за да поръчаш",
    dynamicQRDisabled: "Динамичният QR е деактивиран за този хотел",
  },
  package: {
    fieldRequired: "Полето е задължително",
    codeRequired: "Кодът е задължителен",
    codeMaxLength: "Кодът не може да е по-дълъг от 10 символа",
    codeAlreadyUsed: "Кодът {code} вече се използва.",
    saveSuccess: "{title} {code} беше {action}.",
    saveFailed: "Неуспешно {action} на {title} {code}.",
    actionSaved: "записан",
    actionUpdated: "обновен",
    confirmRemoveItems: "Сигурни ли сте, че искате да премахнете избраните елементи?",
    deleteTitle: "Изтриване",
    deleteSuccess: "Елемент(и) беше изтрит.",
    deleteFailed: "Неуспешно изтриване на избраните елементи.",
    addOutletSuccess: "Търговският обект беше добавен към пакет {code}.",
    addOutletFailed: "Неуспешно добавяне на търговски обект към пакет {code}.",
    addArticleSuccess: "Артикулът беше добавен към пакет {code}.",
    addArticleFailed: "Неуспешно добавяне на артикул към пакет {code}.",
    showPackageOrderDetailPriceMode: "Видимост на цената в детайла на пакетната поръчка",
    showPackageDetailOnInvoice: "Показване на детайли на пакета във фактурата",
    packageOrderDetailPriceModeFollowParameter: "Следвай POS параметъра",
    packageOrderDetailPriceModeForceShow: "Презапис: Показвай",
    packageOrderDetailPriceModeForceHide: "Презапис: Скрий",
    itemsLabel: "Избрани {count} елемент(а)",
    remove: "Премахни",
    assignOutlet: "Назначи обект",
    assignArticle: "Назначи артикул",
    saveBeforeManagingRelations: "Запазете пакета преди да управлявате обекти или артикули.",
    emptyPreviewResponse: "Прегледът на пакета не върна съдържание.",
    noArticlesInPreview: "Пакетът няма артикули за добавяне.",
  },
  tableLabelManagement: {
    accessibility: "Достъпност",
    addLabel: "Добави етикет",
    allCategories: "Всички категории",
    allowMultipleHint: "Когато е отметнато, таблиците могат да имат множество етикети от тази категория (например 'С изглед към океана' + 'С изглед към басейна'). Когато не е отметнато, се допуска само един етикет (например 'Вътрешен' или 'Външен').",
    allowMultipleLabels: "Позволи множество етикети от тази категория",
    allowMultipleSingleInfo: "Категориите, маркирани като 'Изберете едно', позволяват само един етикет на таблица, докато категориите 'Позволени множество' ви позволяват да зададете множество етикети от тази категория.",
    appliedLabels: "Приложени етикети",
    category: "Категория",
    categoryDescriptionContent: "Категориите групират свързани етикети. Например, 'Физическо местоположение' е категория, съдържаща етикети като Вътре, Навън, Патио и др.",
    categoryDescriptionTitle: "Какви са категориите?",
    categoryGroup: "Група категории",
    categoryGroupHelp: "Групирайте подобни категории в потребителския интерфейс",
    categoryName: "Име на категорията",
    chooseAColorThatMakesThisLabelEasyToIdentify: "Изберете цвят, който улеснява идентификацията на етикета.",
    clearLabelsFilter: "Изчисти филтъра за етикети",
    climateControl: "Климатичен контрол",
    createNewCategory: "Създаване на нова категория",
    createNewCategoryDescription: "Добавете персонализирана категория етикети за вашите таблици",
    createNewLabel: "Създаване на нов етикет",
    createNewLabelDescription: "Добавете персонализиран етикет за категоризиране на вашите таблици",
    customLabels: "Персонализирани етикети",
    description: "Описание",
    editCategory: "Редактиране на категория",
    editLabel: "Редактиране на етикет",
    environment: "Среда",
    examples: "Примери",
    familyFeatures: "Семейни функции",
    filterByLabels: "Филтрирай по етикети",
    guest: "Гост",
    importSystemLabels: "Импорт на системни етикети",
    labelColor: "Цвят на етикета",
    labelDescriptionContent: "Етикетите са специфични атрибути, които можете да присвоите на таблици. Например, в категорията „Физическо местоположение“ можете да имате етикети като „Вътре“, „Навън“, „Тераса“ и др.",
    labelDescriptionTitle: "Какви са етикетите?",
    labelName: "Име на етикет",
    labels: "Етикети",
    labelsAreSpecificToEachOutlet: "Етикетите са специфични за всяко заведение",
    labelsInUse: "Етикети в употреба",
    manageLabels: "Управление на етикети",
    managingLabelsFor: "Управление на етикети за",
    modifyCategoryDescription: "Променете настройките на категорията '{x}'",
    modifyLabelDescription: "Променете етикета '{x}'",
    multipleAllowed: "Позволени множество",
    multiSelectCategories: "Мулти избор на категории",
    newCategory: "Нова категория",
    operational: "Оперативен",
    ordersLast30d: "Поръчки (30Д)",
    organizeAndCustomizeTableLabelsForYourOutlets: "Организирайте и персонализирайте етикетите на масите за вашите обекти",
    outlets: "Точки за продажба",
    physicalLocation: "Физическо местоположение",
    preview: "Преглед",
    seating: "Седалки",
    seeLess: "Виж по-малко",
    selectionRules: "Правила за избор",
    selectOne: "Изберете един",
    service: "Услуга",
    singleSelectCategories: "Едноизборни категории",
    smokingPolicy: "Политика за пушене",
    sortOrder: "Ред на сортиране",
    system: "Система",
    systemCategory: "Системна категория",
    systemCategoryMessage: "Това е системна категория. Можете да променяте настройки като 'Позволи множество' и 'Покажи група', но името на категорията не може да бъде променяно. Помислете за създаване на персонализирана категория, ако имате нужда от различно наименование.",
    systemLabel: "Системен етикет",
    systemLabelMessage: "Това е системен етикет. Можете да променяте цвета и други настройки, но името на етикета не може да бъде променяно. Помислете за създаване на персонализиран етикет, ако имате нужда от различно име.",
    systemLabels: "Системни етикети",
    tableLabels: "Етикети на таблици",
    tablesUsing: "Таблици, използващи",
    thisCategoryAllowsMultipleLabelsPerTable: "Тази категория позволява множество етикети на таблица.",
    thisCategoryAllowsOnlyOneLabelPerTable: "Тази категория позволява само една етикетка на таблица.",
    tip: "Съвет",
    totalCategories: "Общо категории",
    totalLabels: "Общо етикети",
    usageStatistics: "Статистика за употреба",
    usedByXTables: "Използва се от {x} таблици",
    viewType: "Тип изглед",
    xLabels: "{x} етикета",
    xMore: "+{x} още",
    edcMachineIntegration: "Интеграция на EDC машина",
    enableEdcMachine: "Активирайте EDC машина",
    edcMode: "EDC Режим",
    edcModeAlways: "Винаги използвайте EDC",
    edcModePrompt: "Подсказване на касиера за избор",
    edcAgentUrl: "URL на Sentec агент",
    edcAgentUrlPlaceholder: "Оставете празно, за да използвате pos.agent URL",
    edcAgentUrlHint: "Връща се към URL на pos.agent, ако не е зададен",
    edcAgentToken: "Токен на агент Sentec",
    edcAgentTokenPlaceholder: "Оставете празно, за да използвате токена на pos.agent",
    edcAgentTokenHint: "Заменя токена pos.agent при задаване",
    edcVendor: "Доставчик на EDC",
    edcComPort: "COM порт",
    edcComPortPlaceholder: "напр. COM3",
    edcTestConnection: "Тест на връзката",
    edcConnected: "Свързано",
    edcFailed: "Неуспешно",
    edcEnterAgentUrlFirst: "Моля, въведете URL адреса на Sentec Agent първо.",
    edcPayment: "Плащане EDC",
    edcInvoiceAmountRemaining: "Оставаща сума на фактурата",
    edcUserPayment: "Плащане на потребителя",
    edcTerminalWillReceive: "Терминалът ще получи: {amount} ({currency} малки единици)",
    edcChange: "Промяна",
    edcRemainingPayment: "Оставаща сума",
    edcPressPayToInitiate: "Натиснете Плати, за да стартирате EDC транзакция",
    edcWaitingForCard: "Изчакване на докосване/вмъкване на карта...",
    edcSecondsRemaining: "{seconds}с оставащи",
    edcCancel: "Отказване",
    edcTransactionApproved: "Транзакцията е одобрена",
    edcTransactionFailed: "Транзакцията не успя",
    edcRetry: "Опитай отново",
    edcPayViaEdc: "Плащане чрез EDC",
    edcConfirm: "Потвърди",
    edcCard: "Картичка",
    edcAuthCode: "Код за удостоверяване",
    edcTraceNumber: "Проследяване #",
    edcTerminal: "Терминал",
    edcTransactionDeclined: "Транзакцията е отказана",
    edcConnectionFailed: "Неуспешно свързване с EDC терминал",
    edcTotalPaymentAlreadyEqual: "Общото плащане вече е равно на сумата на фактурата.",
  },
  orderNotification: {
    newOrderTitle: "Нова поръчка",
    newOrderMessage: "Нова поръчка от {guest} в {outlet} ({location}) — {count} артикула, количество {qty}",
    orderCanceledMessage: "Поръчка #{orderId} от {guest} в {outlet} е отменена",
    orderUndoCanceledMessage: "Поръчка #{orderId} от {guest} в {outlet} отмяната е отменена",
    orderAssignedToTableMessage: "Поръчка #{orderId} от {guest} в {outlet} е присвоена на маса",
  },
  tag: {
    title: "Тагове",
    tag: "Таг",
    parent: "Родител",
    parents: "Родители",
    navigate: "Навигирай",
    tagsNavigation: "Навигация по тагове",
    revenueCenterNotSet: "Артикулът няма зададен център на приходи",
    submenu: "Подменю",
    home: "Начало",
    menuHasNotBeenSetup: "Менюто не е настроено",
    removeNItems: "Премахни {n} елемент(и)",
    nItems: "{n} артикула",
    seeArticleLocations: "Виж местоположения на артикули",
    articleLocations: "Местоположения на артикули",
    seeArticleGroups: "Виж групи артикули",
    seeMenuTags: "Виж тагове на менюто",
  },
  salesDocuments: {
    salesReturnTitle: "Връщане на продажба",
    salesRefundTitle: "Възстановяване на продажба",
    reasonForRefund: "ПРИЧИНА ЗА ВЪЗСТАНОВЯВАНЕ: {value}",
    authorizer: "УПЪЛНОМОЩИЛ: {value}",
    printSalesReturn: "Отпечатай връщане на продажба",
    printSalesRefund: "Отпечатай възстановяване на продажба",
    billPrinterNotConfigured: "Няма конфигуриран принтер за сметки за този обект.",
    printAgentNotConfigured: "Няма конфигуриран принтерен агент за това устройство.",
  },
  eJournal: {
    typeSalesInvoice: "Фактура за продажба",
    typeAcknowledgementReceipt: "Потвърдителна бележка",
    typeVoid: "Анулиране",
    typeCreditMemo: "Кредитно известие",
    typeCancel: "Отказ",
    businessName: "Име на фирмата",
    period: "Период",
    createdBy: "Създадено от",
    pdfSaved: "Запазено {file} — {pages} страница(и).",
    pdfUnsupportedChars: "PDF файлът не може да възпроизведе тези символи: {chars}. Изтегленият .txt файл е официалното копие.",
    title: "BIR електронен дневник",
    dateFrom: "От дата",
    dateTo: "До дата",
    lineWidth: "Широчина на реда",
    generate: "Генериране",
    downloadTxt: "Изтегли .txt",
    allOutlets: "Всички обекти",
    noPermission: "Нямате права да виждате BIR електронния дневник.",
    emptyState: "Не са издадени фискални документи за {outlet} между {from} и {to}.",
    progress: "Генериране на {outlet} ({n} документа)...",
    logTitle: "Дневник на корекциите в POS",
    logNoPermission: "Нямате права да виждате Дневника на корекциите в POS.",
    adjustmentType: "Тип корекция",
    allTypes: "Всички типове",
    logDate: "Дата на запис",
    orNo: "Номер на бележка",
    originalOrDate: "Дата на оригинала",
    transactionNo: "Номер на транзакция",
    cashier: "Касиер",
    approvedBy: "Одобрено от (оператор)",
    grossAmount: "Брутна сума",
    vatAmount: "ДДС сума",
    netAmount: "Нетна сума",
    paymentMethod: "Начин на плащане",
    reason: "Причина",
    remarks: "Забележки (изведени)",
    derivedNote: "Забележките се извеждат от транзакцията; Одобрено от показва оператора, извършил корекцията.",
    unresolvedDates: "{n} ред(а) не можаха да установят оригиналната дата.",
    logEmptyState: "Няма записани корекции за {outlet} между {from} и {to}.",
  },
  tableLayout: {
    floorplanTooLarge: "Планът е {size} MB; максимумът е {max} MB",
    designerTitle: "Разположение на масите",
    publishToPos: "Покажи това разположение в POS",
    pickAnOutlet: "Изберете обект, за да проектирате разположението",
    loadOutletsFailed: "Обектите не можаха да бъдат заредени",
    loadTablesFailed: "Масите не можаха да бъдат заредени",
    saveFailed: "{n} елемента не бяха запазени",
    saveSucceeded: "Разположението е запазено",
    floorplan: "План",
    unplaced: "Неразположени",
    allPlaced: "Всички маси са разположени",
    shape: "Форма",
    shapeRectangle: "Правоъгълник",
    shapeSquare: "Квадрат",
    shapeCircle: "Кръг",
    shapeEllipse: "Елипса",
    shapeTriangle: "Триъгълник",
    removeFromLayout: "Премахни от плана",
    selectATable: "Изберете маса",
    blockingIssues: "{n} маса(и) извън платното",
    overlapWarning: "{n} застъпващи се двойки",
    layoutView: "Изглед на разположението",
    booked: "Резервирана",
    nudge: "Премести",
    nudgeDown: "Премести 1 px надолу",
    nudgeLeft: "Премести 1 px наляво",
    nudgeRight: "Премести 1 px надясно",
    nudgeUp: "Премести 1 px нагоре",
  },
  waiterPin: {
    dialogTitle: "Изисква се авторизиран ПИН",
    pinLabel: "ПИН на ръководителя",
    verify: "Потвърдете",
    invalidPin: "Невалиден ПИН. Моля, опитайте отново.",
    unauthorizedAction: "Свързаният потребител на този сервитьор няма разрешение да извърши това действие.",
    linkedUser: "Свързан потребител",
    pinFieldLabel: "ПИН",
    pinFieldHint: "ПИН от 4 до 8 цифри. Оставете празно при редакция, за да запазите текущия ПИН.",
    associatedUserLabel: "Свързан потребител",
    clearPinLabel: "Изчисти текущия ПИН",
    authorizedWaiter: "Упълномощен сервитьор",
    authorizedUser: "Упълномощен потребител",
    voidAuthorizedWaiter: "Отменен упълномощен сервитьор",
    voidAuthorizedUser: "Неактивен упълномощен потребител",
  },
  localVoidDocumentFilter: {
    showCreditMemoVoidOnly: "Покажи само кредитни известия / анулирания",
    chooseMode: "Изберете кои анулирани поръчки / кредитни известия да се покажат",
    reversalDocuments: "Сторниращи документи",
    originalOrders: "Оригинални поръчки",
    both: "И двете",
    columnHeader: "Роля на анулиране / кредитно известие",
    roleReversal: "Сторниращ документ",
    roleOriginal: "Оригинална поръчка",
  },
}
